export const GET_BANKS = 'creditorCatalog/GET_BANKS';
export const GET_CREDIT_CARD_BANKS = 'creditorCatalog/GET_CREDIT_CARD_BANKS';
